import { Component } from "react"
import PropTypes from "prop-types"
import pubsub from "./pubsub"

function tooltipContainer(WrappedComponent) {
  class TooltipContainer extends Component {
    static propTypes = {
      publish: PropTypes.func.isRequired,
      subscribe: PropTypes.func.isRequired,
      unsubscribe: PropTypes.func.isRequired,
    }

    onMouseMove = ({ pageX, pageY, currentTarget }) => {
      const { publish } = this.props
      // cannot use offsetX and offsetY because they are not relative to currentTarget in Firefox
      const box = currentTarget.getBoundingClientRect()
      const offsetX = pageX - box.left
      const offsetY = pageY - box.top
      const maxX = box.right
      publish({ showToolTip: true, nativeEvent: { offsetX, offsetY, pageX, pageY, maxX } })
    }

    onMouseLeave = () => {
      const { publish } = this.props
      publish({ showToolTip: false })
    }

    render() {
      return <div className="hocs_tooltip-container" onMouseMove={this.onMouseMove} onMouseLeave={this.onMouseLeave}>
        <WrappedComponent {...this.props} />
      </div>
    }
  }

  return pubsub(TooltipContainer)
}

export default tooltipContainer
